import { useRef, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useIsMobile } from '@/shared/hooks/use-media-query'
import { useDarkMode } from '@/shared/hooks/use-dark-mode'
import { TopBar } from './top-bar'
import { SidebarContent } from './sidebar'
import { cn } from '@/lib/utils'

export function MainLayout() {
  const isMobile = useIsMobile()
  const mainRef = useRef<HTMLElement>(null)
  const { pathname } = useLocation()
  const { isDark, toggleDark } = useDarkMode()

  useEffect(() => {
    mainRef.current?.scrollTo(0, 0)
  }, [pathname])

  return (
    <div className={cn(isDark && 'dark', 'flex h-screen flex-col overflow-hidden bg-neutral-50')}>
      <TopBar />

      <div className="flex flex-1 overflow-hidden">
        {/* Desktop sidebar */}
        {!isMobile && (
          <aside className="hidden md:flex w-56 shrink-0 flex-col border-r border-neutral-200 bg-white">
            <SidebarContent isDark={isDark} onToggleDark={toggleDark} />
          </aside>
        )}

        {/* Page content */}
        <main
          ref={mainRef}
          className={cn(
            'flex-1 overflow-y-auto',
            !isMobile && 'p-6 lg:p-8',
          )}
        >
          <Outlet />
        </main>
      </div>
    </div>
  )
}
